import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { ShoppingCart } from "lucide-react";

export function ContactModal({ open, onOpenChange, form, onFormChange, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-[#6A7359] flex items-center gap-2">
            <ShoppingCart className="w-5 h-5" />
            Checkout
          </DialogTitle>
          <DialogDescription>Enter your details to proceed to secure checkout.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-3">
          <Input 
            placeholder="Full Name *" 
            value={form.name} 
            onChange={(e) => onFormChange("name", e.target.value)} 
            data-testid="contact-name" 
          />
          <Input 
            placeholder="Email *" 
            type="email"
            value={form.email} 
            onChange={(e) => onFormChange("email", e.target.value)} 
            data-testid="contact-email" 
          />
          <Input 
            placeholder="Phone *" 
            type="tel"
            value={form.phone} 
            onChange={(e) => onFormChange("phone", e.target.value)} 
            data-testid="contact-phone" 
          />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1">
              Cancel
            </Button>
            <Button 
              onClick={onSubmit} 
              className="flex-1 bg-[#6D7175] hover:bg-[#5A5E61]" 
              data-testid="submit-contact-btn"
            >
              <ShoppingCart className="w-4 h-4 mr-2" />
              Proceed to Checkout
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
